import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { OrganismeFormation } from '@features/referentiel/models/organisme-formation';
import { EntiteConfig } from '@features/referentiel/config/entite.config';

@Injectable({
  providedIn: 'root',
})
export class EntiteService {
  constructor(private httClient: HttpClient) {}

  getEntitePerPage(
    siret: string,
    itemsPerPage: number,
    page: number,
    isCfa: boolean,
  ): Observable<OrganismeFormation[]> {
    return this.httClient
      .get<any>(
        `${EntiteConfig.beneficiaireList}?siret=${siret}&size=${itemsPerPage}&page=${page}&cfa=${isCfa}`,
      )
      .pipe(map((data) => data.response));
  }

  getEntites(siret: string): Observable<OrganismeFormation[]> {
    return this.getEntitePerPage(siret, 500, 0, false);
  }
}
